import { FilterOperator } from "domain/asset-management/assetFilterConstants";
import { AssetPathKey } from "domain/asset-management/assetPathMapping";
import { GRADING_ACTION_DETAIL_KEY } from "domain/asset-management/assets";
import { AssetFilter, AssetSearchRequest } from "services/asset-management/AssetService";

export enum GradeTab {
    ALL = "ALL",
    GRADE_A = "A",
    GRADE_B = "B",
    GRADE_C = "C",
    GRADE_D = "D",
}

export const MOBILE_PHONE_DEVICE_TYPE_FILTER = "Mobile phone";
export const DEVICE_TYPE_FILTERS = [MOBILE_PHONE_DEVICE_TYPE_FILTER, "Laptop", "Tablet", "Server"];
export const OTHER_DEVICE_TYPE_FILTER = "other";

const DEVICE_TYPE_ALIASES: Record<string, string[]> = {
    [MOBILE_PHONE_DEVICE_TYPE_FILTER]: ["phone", "mobile phone", "mobile device", "mobile", "smartphone", "cell phone"],
};

const ALL_LISTED_DEVICE_TYPES = DEVICE_TYPE_FILTERS.flatMap(toDeviceTypeAliases);

const IN_VALUE_SEPARATOR = ",";

const GRADING_TABLE_PATHS: string[] = [
    AssetPathKey.ASSET_ID,
    AssetPathKey.UUID,
    AssetPathKey.ASSET_TYPE,
    AssetPathKey.MODEL,
    AssetPathKey.BLANCCO_GRADE,
    GRADING_ACTION_DETAIL_KEY,
];

function toGradeFilter(activeTab: GradeTab): AssetFilter | undefined {
    if (activeTab === GradeTab.ALL) {
        return undefined;
    }
    return { name: AssetPathKey.BLANCCO_GRADE, value: activeTab, operator: FilterOperator.MATCH };
}

function toDeviceTypeAliases(deviceTypeFilter: string): string[] {
    return DEVICE_TYPE_ALIASES[deviceTypeFilter] ?? [deviceTypeFilter];
}

function toDeviceTypeFilter(selectedDeviceTypeFilter?: string): AssetFilter | undefined {
    if (selectedDeviceTypeFilter === undefined) {
        return undefined;
    }
    if (selectedDeviceTypeFilter === OTHER_DEVICE_TYPE_FILTER) {
        return {
            name: AssetPathKey.ASSET_TYPE,
            value: ALL_LISTED_DEVICE_TYPES.map((each) => each.toLowerCase()).join(IN_VALUE_SEPARATOR),
            operator: FilterOperator.NOT_IN,
        };
    }
    const aliases = toDeviceTypeAliases(selectedDeviceTypeFilter).map((each) => each.toLowerCase());
    if (aliases.length === 1) {
        return { name: AssetPathKey.ASSET_TYPE, value: aliases[0], operator: FilterOperator.MATCH };
    }
    return { name: AssetPathKey.ASSET_TYPE, value: aliases.join(IN_VALUE_SEPARATOR), operator: FilterOperator.IN };
}

export function buildGradingTableQuickFilters(activeTab: GradeTab, selectedDeviceTypeFilter?: string): AssetFilter[] {
    return [toGradeFilter(activeTab), toDeviceTypeFilter(selectedDeviceTypeFilter)].filter(
        (filter): filter is AssetFilter => filter !== undefined
    );
}

export function buildGradingTableSearchRequest(
    baseRequest: AssetSearchRequest | undefined,
    quickFilters: AssetFilter[]
): AssetSearchRequest {
    const request: AssetSearchRequest = { ...(baseRequest ?? { paths: [] }), paths: GRADING_TABLE_PATHS };
    if (quickFilters.length === 0) {
        return request;
    }
    return { ...request, quickFilters: [...(baseRequest?.quickFilters ?? []), ...quickFilters] };
}
